import React from 'react';
import ServicesHero from '../components/services/ServicesHero';
import ServicesOverview from '../components/services/ServicesOverview';
import CorporateEthos from '../components/services/CorporateEthos';
import Seo from '../components/seo/Seo';

const Services: React.FC = () => {
  return (
    <main className="bg-black text-white pt-20">
      <Seo
        title="Real Estate Services"
        description="Explore Hogar Dorado House services across investment advisory, property transactions, management, leasing, and Golden Visa concierge for UAE and USA markets."
        pathname="/services"
        keywords={[
          'real estate services',
          'investment advisory',
          'property sales',
          'property leasing',
          'Golden Visa services',
          'Dubai property management',
          'best real estate services Dubai',
          'America property management',
          'premium property advisory',
          'luxury property consulting'
        ]}
      />
      <ServicesHero />
      <ServicesOverview />
      <CorporateEthos />
    </main>
  );
};

export default Services;